// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__DzOlH","title":"Images90_title__3W91x","images":"Images90_images__GPK6x"};